import { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons (Webpack strips the URL handles)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const colored = (color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};width:18px;height:18px;border-radius:50%;border:3px solid #fafaf9;box-shadow:0 2px 6px rgba(0,0,0,0.3)"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});
const pickupIcon = colored("#065f46");
const dropoffIcon = colored("#b45309");
const driverIcon = colored("#0ea5e9");

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points || points.length < 1) return;
    const bounds = L.latLngBounds(points);
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
  }, [points, map]);
  return null;
}

export default function LiveDeliveryMap({ pickup, dropoff, driver }) {
  const center = pickup || dropoff || driver || { lat: 37.7749, lng: -122.4194 };
  const points = [pickup, driver, dropoff].filter(Boolean).map((p) => [p.lat, p.lng]);
  const route = [driver || pickup, dropoff].filter(Boolean).map((p) => [p.lat, p.lng]);

  return (
    <div data-testid="leaflet-map" className="h-72 sm:h-80 rounded-md overflow-hidden border border-stone-200">
      <MapContainer center={[center.lat, center.lng]} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {pickup && <Marker position={[pickup.lat, pickup.lng]} icon={pickupIcon}><Popup>Pickup</Popup></Marker>}
        {dropoff && <Marker position={[dropoff.lat, dropoff.lng]} icon={dropoffIcon}><Popup>Drop-off</Popup></Marker>}
        {driver && <Marker position={[driver.lat, driver.lng]} icon={driverIcon}><Popup>Driver — live</Popup></Marker>}
        {route.length === 2 && <Polyline positions={route} pathOptions={{ color: "#065f46", weight: 3, dashArray: "8 8" }} />}
        <FitBounds points={points} />
      </MapContainer>
    </div>
  );
}

export function useDriverGeolocation(active, onPosition) {
  const watchId = useRef(null);
  useEffect(() => {
    if (!active || !navigator.geolocation) return;
    watchId.current = navigator.geolocation.watchPosition(
      (pos) => onPosition({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => console.warn("geolocation error", err),
      { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
    );
    return () => {
      if (watchId.current != null) navigator.geolocation.clearWatch(watchId.current);
    };
  }, [active, onPosition]);
}
